import { Box, CloseButton, HStack, Tag } from "@chakra-ui/react";
import MarkDownRender from "../MarkDownRender";
import { QuizState } from "../elements/Quiz/types";

type IProps = {
  hint: QuizState["hint"];
  isHintShowed: QuizState["isHintShowed"];
  onClick: () => void;
};

const QuizHint = ({ hint, isHintShowed, onClick }: IProps) => {
  if (isHintShowed && hint) {
    return (
      <Box
        mt={"1rem"}
        p={"1rem"}
        sx={{
          border: "1px solid",
          borderColor: "neutral.800",
          borderRadius: "1rem",
        }}
      >
        <HStack justifyContent={"space-between"}>
          <Tag colorScheme="yellow" variant={"subtle"}>
            hint
          </Tag>
          <CloseButton onClick={onClick} />
        </HStack>
        <Box>
          <MarkDownRender content={hint}></MarkDownRender>
        </Box>
      </Box>
    );
  }
};

export default QuizHint;
